// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import './App.css';
// import Dashboard from './Pages/Dashboard';
// import SignIn from './Pages/SignIn';
// import Registration from './Pages/Registration';
// import ProtectedRoute from './ProtectedRoute';
// import SignIn1 from './Pages/SIgnIn1';
// import Home from './Pages/Home/Home';

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           {/* Public routes */}
//           <Route path="/signin" element={<SignIn />} />
//            <Route path="/" element={<Home />} />
//           <Route path="/register" element={<Registration />} />
          
//           {/* Protected Dashboard */}
//           <Route 
//             path="/dashboard" 
//             element={
//               // <ProtectedRoute>
//                 <Dashboard />
//               // </ProtectedRoute>
//             } 
//           />
          
        
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import './App.css';
// import Dashboard from './Pages/Dashboard';
// import SignIn from './Pages/SignIn';
// import Registration from './Pages/Registration';
// import Home from './Pages/Home/Home';

// function App() {
//   return (
//     <div className="App">
//       <Routes>
//         {/* Public routes */}
//         <Route path="/signin" element={<SignIn />} />
//         <Route path="/" element={<Home />} />
//         <Route path="/register" element={<Registration />} />

//         {/* Protected Dashboard */}
//         <Route
//           path="/dashboard"
//           element={<Dashboard />}
//         />
//       </Routes>
//     </div>
//   );
// }

// export default App;

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Dashboard from './Pages/Dashboard';
import SignIn from './Pages/SignIn';
import Registration from './Pages/Registration';
import Home from './Pages/Home/Home';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import PaymentReport from './Pages/Dashboard/PaymentReport';
import Demo from './Pages/Demo';
import WalletTransfer from './Pages/Dashboard/WalletTransfer';
import WalletTransaction from './Pages/Dashboard/WalletTransaction';
import ChangePassword from './Pages/Dashboard/ChangePassword';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { token, isAuthenticated } = useSelector((state) => state.user);
  
  // Check if token exists and is valid
  const isTokenValid = () => {
    if (!token) return false;
    
    try {
      // Decode token to check expiry
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Check if token is expired
      if (decodedToken.exp < currentTime) {
        console.log('Token expired');
        return false;
      }
      
      return true;
    } catch (error) {
      console.log('Invalid token:', error);
      return false;
    }
  };

  // Check both Redux state and localStorage for backward compatibility
  const hasValidToken = () => {
    // Check Redux state first
    if (isAuthenticated && token && isTokenValid()) {
      return true;
    }
    
    // Check localStorage as fallback
    const localToken = localStorage.getItem('willowToken');
    if (localToken) {
      try {
        const decodedToken = jwtDecode(localToken);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp >= currentTime) {
          return true;
        } else {
          // Remove expired token
          localStorage.removeItem('willowToken');
          localStorage.removeItem('willowUser');
        }
      } catch (error) {
        console.log('Invalid local token:', error);
        localStorage.removeItem('willowToken');
        localStorage.removeItem('willowUser');
      }
    }
    
    return false;
  };

  if (!hasValidToken()) {
    // Redirect to login if no valid token
    return <Navigate to="/signin" replace />;
  }

  return children;
};

// Public Route Component (redirects to dashboard if already logged in)
const PublicRoute = ({ children }) => {
  const { token, isAuthenticated } = useSelector((state) => state.user);
  
  const isTokenValid = () => {
    if (!token) return false;
    
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      if (decodedToken.exp < currentTime) {
        return false;
      }
      
      return true;
    } catch (error) {
      return false;
    }
  };

  const hasValidToken = () => {
    if (isAuthenticated && token && isTokenValid()) {
      return true;
    }
    
    const localToken = localStorage.getItem('willowToken');
    if (localToken) {
      try {
        const decodedToken = jwtDecode(localToken);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp >= currentTime) {
          return true;
        }
      } catch (error) {
        return false;
      }
    }
    
    return false;
  };

  if (hasValidToken()) {
    // Redirect to dashboard if already authenticated
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes - only accessible when NOT logged in */}
        <Route path="/signin" element={
          <PublicRoute>
            <SignIn />
          </PublicRoute>
        } />
         <Route path="/demo" element={
          <PublicRoute>
            <Demo />
          </PublicRoute>
        } />
        
        <Route path="/" element={<Home />} />
        
        <Route path="/register" element={
          <PublicRoute>
            <Registration />
          </PublicRoute>
        } />

        {/* Protected Dashboard - only accessible with valid token */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
  path="/wallet-transfer"
  element={
    <ProtectedRoute>
      <WalletTransfer />
    </ProtectedRoute>
  }
/>

        <Route
  path="/wallet-transaction"
  element={
    <ProtectedRoute>
      <WalletTransaction />
    </ProtectedRoute>
  }
/>
         <Route
          path="/payment-report"
          element={
            <ProtectedRoute>
              <PaymentReport/>
            </ProtectedRoute>
          }
        />

      
<Route
  path="/change-password"
  element={
    <ProtectedRoute>
      <ChangePassword />
    </ProtectedRoute>
  }
/>

        {/* Catch all route - redirect to home or login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;